import { cva } from "class-variance-authority"

export { default as Button } from "./Button.vue"
export { default as YesNoButtons } from "./YesNoButtons.vue"

export const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-afbranding-cta text-primary-foreground hover:bg-afbranding-cta-hover rounded-full lg:whitespace-nowrap",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-transparent",
        tertiary:
          "bg-white border border-gray-300 rounded-full hover:bg-grey-lighten-4 hover:border-transparent",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        empty: "",
      },
      size: {
        default: "px-8 py-3",
        sm: "px-3",
        lg: "px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)
